import { IconSparkles } from '@tabler/icons-react';
import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@cfa/react-components';

const TryItOut: React.FC = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      className="flex items-center gap-2"
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <IconSparkles className="text-brand-dark-gray" />
      <Typography variant="body1">{t('AISearchPOC.tryBetaText')}</Typography>
    </motion.div>
  );
};

export default TryItOut;
